import { Phone } from 'lucide-react';
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '../constants/site';

/** Floating blue call button (screenshot reference) */
export default function CallFab() {
  return (
    <a href={`tel:${SUPPORT_PHONE_TEL}`} className="ftm-call-fab" aria-label={`Call ${SUPPORT_PHONE_DISPLAY}`}>
      <Phone size={22} strokeWidth={2.5} aria-hidden />
      <span className="tabular-nums">{SUPPORT_PHONE_DISPLAY}</span>
    </a>
  );
}
